module.exports = __webpack_public_path__ + "static/dl2-stay-human_mobile-225823bde8aec26c374d5f0bb0f9c7fd.png";